export const DepartmentsCategoryColumns = [
  {
    Header: 'Category Name',
    accessor: 'name',
  },
  {
    Header: 'Descrption',
    accessor: 'description',
  },
  {
    Header: "Department",
    accessor: "department_category",
  },
  // {
  //     Header: 'Status',
  //     accessor: '',
  // },
  {
    Header: "Inventory Items",
    accessor: "category_items",
  },
  {
    Header: 'Actions',
    accessor: 'actions',
  }
];
